module.exports = __webpack_public_path__ + "img/cwg_zhuanyong_kongzhiqi.4762273d.png";